/* eslint-disable quote-props */
export const CITIES_OF_CANADA = {
  'alberta': [
    { name: 'Airdrie' },
    { name: 'Grande Prairie' },
    { name: 'Red Deer' },
    { name: 'Beaumont' },
    { name: 'Hanna' },
    { name: 'St. Albert' },
    { name: 'Bonnyville' },
    { name: 'Hinton' },
    { name: 'Spruce Grove' },
    { name: 'Brazeau' },
    { name: 'Irricana' },
    { name: 'Strathcona County' },
    { name: 'Breton' },
    { name: 'Lacombe' },
    { name: 'Strathmore' },
    { name: 'Calgary' },
    { name: 'Leduc' },
    { name: 'Sylvan Lake' },
    { name: 'Camrose' },
    { name: 'Lethbridge' },
    { name: 'Swan Hills' },
    { name: 'Canmore' },
    { name: 'McLennan' },
    { name: 'Taber' },
    { name: 'Didzbury' },
    { name: 'Medicine Hat' },
    { name: 'Turner Valley' },
    { name: 'Drayton Valley' },
    { name: 'Olds' },
    { name: 'Vermillion' },
    { name: 'Edmonton' },
    { name: 'Onoway' },
    { name: 'Wood Buffalo' },
    { name: 'Ft. Saskatchewan' },
    { name: 'Provost' },
  ],
  'british-columbia': [
    { name: 'Burnaby' },
    { name: 'Lumby' },
    { name: 'City of Port Moody' },
    { name: 'Cache Creek' },
    { name: 'Maple Ridge' },
    { name: 'Prince George' },
    { name: 'Castlegar' },
    { name: 'Merritt' },
    { name: 'Prince Rupert' },
    { name: 'Chemainus' },
    { name: 'Mission' },
    { name: 'Richmond' },
    { name: 'Chilliwack' },
    { name: 'Nanaimo' },
    { name: 'Saanich' },
    { name: 'Clearwater' },
    { name: 'Nelson' },
    { name: 'Sooke' },
    { name: 'Colwood' },
    { name: 'New Westminster' },
    { name: 'Sparwood' },
    { name: 'Coquitlam' },
    { name: 'North Cowichan' },
    { name: 'Surrey' },
    { name: 'Cranbrook' },
    { name: 'North Vancouver' },
    { name: 'Terrace' },
    { name: 'Dawson Creek' },
    { name: 'Tumbler' },
    { name: 'Delta' },
    { name: 'Osoyoos' },
    { name: 'Vancouver' },
    { name: 'Fernie' },
    { name: 'Parksville' },
    { name: 'Invermere' },
    { name: 'Peace River' },
    { name: 'Vernon' },
    { name: 'Kamloops' },
    { name: 'Penticton' },
    { name: 'Victoria' },
    { name: 'Kaslo' },
    { name: 'Port Alberni' },
    { name: 'Whistler' },
    { name: 'Langley' },
    { name: 'Port Hardy' },
  ],
  'manitoba': [
    { name: 'Birtle' },
    { name: 'Flin Flon' },
    { name: 'Swan River' },
    { name: 'Brandon' },
    { name: 'Snow Lake' },
    { name: 'The Pas' },
    { name: 'Cranberry Portage' },
    { name: 'Steinbach' },
    { name: 'Thompson' },
    { name: 'Dauphin' },
    { name: 'Stonewall' },
    { name: 'Winnipeg' },
  ],
  'new-brunswick': [
    { name: 'Cap-Pele' },
    { name: 'Miramichi' },
    { name: 'Saint John' },
    { name: 'Fredericton' },
    { name: 'Moncton' },
    { name: 'Saint Stephen' },
    { name: 'Grand Bay-Westfield' },
    { name: 'Oromocto' },
    { name: 'Shippagan' },
    { name: 'Grand Falls' },
    { name: 'Port Elgin' },
    { name: 'Sussex' },
    { name: 'Memramcook' },
    { name: 'Sackville' },
    { name: 'Tracadie-Sheila' },
  ],
  'newfoundland-and-labrador': [
    { name: 'Argentia' },
    { name: 'Corner Brook' },
    { name: 'Paradise' },
    { name: 'Bishop\'s Falls' },
    { name: 'Labrador City' },
    { name: 'Portaux Basques' },
    { name: 'Botwood' },
    { name: 'Mount Pearl' },
    { name: 'St. John\'s' },
    { name: 'Brigus' },
  ],
  'northwest-territories': [
    { name: 'Town of Hay River' },
    { name: 'Town of Inuvik' },
    { name: 'Yellowknife' },
  ],
  'nova-scotia': [
    { name: 'Amherst' },
    { name: 'Hants County' },
    { name: 'Pictou' },
    { name: 'Annapolis' },
    { name: 'Inverness County' },
    { name: 'Pictou County' },
    { name: 'Argyle' },
    { name: 'Kentville' },
    { name: 'Queens' },
    { name: 'Baddeck' },
    { name: 'County of Kings' },
    { name: 'Richmond' },
    { name: 'Bridgewater' },
    { name: 'Lunenburg' },
    { name: 'Shelburne' },
    { name: 'Cape Breton' },
    { name: 'Lunenburg County' },
    { name: 'Stellarton' },
    { name: 'Chester' },
    { name: 'Mahone Bay' },
    { name: 'Truro' },
    { name: 'Cumberland County' },
    { name: 'New Glasgow' },
    { name: 'Windsor' },
    { name: 'East Hants' },
    { name: 'New Minas' },
    { name: 'Yarmouth' },
    { name: 'Halifax' },
    { name: 'Parrsboro' },
  ],
  'nunavut': [
    { name: 'Iqaluit' },
  ],
  'ontario': [
    { name: 'Ajax' },
    { name: 'Halton' },
    { name: 'Peterborough' },
    { name: 'Atikokan' },
    { name: 'Halton Hills' },
    { name: 'Pickering' },
    { name: 'Barrie' },
    { name: 'Hamilton' },
    { name: 'Port Bruce' },
    { name: 'Belleville' },
    { name: 'Hamilton-Wentworth' },
    { name: 'Port Burwell' },
    { name: 'Blandford-Blenheim' },
    { name: 'Hearst' },
    { name: 'Port Colborne' },
    { name: 'Blind River' },
    { name: 'Huntsville' },
    { name: 'Port Hope' },
    { name: 'Brampton' },
    { name: 'Ingersoll' },
    { name: 'Prince Edward' },
    { name: 'Brant' },
    { name: 'James' },
    { name: 'Quinte West' },
    { name: 'Brantford' },
    { name: 'Kanata' },
    { name: 'Renfrew' },
    { name: 'Brock' },
    { name: 'Kincardine' },
    { name: 'Richmond Hill' },
    { name: 'Brockville' },
    { name: 'King' },
    { name: 'Sarnia' },
    { name: 'Burlington' },
    { name: 'Kingston' },
    { name: 'Sault Ste. Marie' },
    { name: 'Caledon' },
    { name: 'Kirkland Lake' },
    { name: 'Scarborough' },
    { name: 'Cambridge' },
    { name: 'Kitchener' },
    { name: 'Scugog' },
    { name: 'Chatham-Kent' },
    { name: 'Larder Lake' },
    { name: 'Souix Lookout CoC Sioux Lookout' },
    { name: 'Chesterville' },
    { name: 'Leamington' },
    { name: 'Smiths Falls' },
    { name: 'Clarington' },
    { name: 'Lennox-Addington' },
    { name: 'South-West Oxford' },
    { name: 'Cobourg' },
    { name: 'Lincoln' },
    { name: 'St. Catharines' },
    { name: 'Cochrane' },
    { name: 'Lindsay' },
    { name: 'St. Thomas' },
    { name: 'Collingwood' },
    { name: 'London' },
    { name: 'Stoney Creek' },
    { name: 'Cornwall' },
    { name: 'Loyalist Township' },
    { name: 'Stratford' },
    { name: 'Cumberland' },
    { name: 'Markham' },
    { name: 'Sudbury' },
    { name: 'Deep River' },
    { name: 'Metro Toronto' },
    { name: 'Temagami' },
    { name: 'Dundas' },
    { name: 'Merrickville' },
    { name: 'Thorold' },
    { name: 'Durham' },
    { name: 'Milton' },
    { name: 'Thunder Bay' },
    { name: 'Dymond' },
    { name: 'Nepean' },
    { name: 'Tillsonburg' },
    { name: 'Ear Falls' },
    { name: 'Newmarket' },
    { name: 'Timmins' },
    { name: 'East Gwillimbury' },
    { name: 'Niagara' },
    { name: 'Toronto' },
    { name: 'East Zorra-Tavistock' },
    { name: 'Niagara Falls' },
    { name: 'Uxbridge' },
    { name: 'Elgin' },
    { name: 'Niagara-on-the-Lake' },
    { name: 'Vaughan' },
    { name: 'Elliot Lake' },
    { name: 'North Bay' },
    { name: 'Wainfleet' },
    { name: 'Flamborough' },
    { name: 'North Dorchester' },
    { name: 'Wasaga Beach' },
    { name: 'Fort Erie' },
    { name: 'North Dumfries' },
    { name: 'Fort Frances' },
    { name: 'North York' },
    { name: 'Waterloo' },
    { name: 'Gananoque' },
    { name: 'Norwich' },
    { name: 'Welland' },
    { name: 'Georgina' },
    { name: 'Oakville' },
    { name: 'Wellesley' },
    { name: 'Glanbrook' },
    { name: 'Orangeville' },
    { name: 'West Carleton' },
    { name: 'Gloucester' },
    { name: 'Orillia' },
    { name: 'West Lincoln' },
    { name: 'Goulbourn' },
    { name: 'Osgoode' },
    { name: 'Whitby' },
    { name: 'Gravenhurst' },
    { name: 'Oshawa' },
    { name: 'Wilmot' },
    { name: 'Grimsby' },
    { name: 'Ottawa' },
    { name: 'Windsor' },
    { name: 'Guelph' },
    { name: 'Ottawa-Carleton' },
    { name: 'Woolwich' },
    { name: 'Haldimand-Norfork' },
    { name: 'Owen Sound' },
    { name: 'York' },
  ],
  'prince-edward-island': [
    { name: 'Alberton' },
    { name: 'Montague' },
    { name: 'Stratford' },
    { name: 'Charlottetown' },
    { name: 'Souris' },
    { name: 'Summerside' },
    { name: 'Cornwall' },
  ],
  'quebec': [
    { name: 'Alma' },
    { name: 'Fleurimont' },
    { name: 'Longueuil' },
    { name: 'Amos' },
    { name: 'Gaspe' },
    { name: 'Marieville' },
    { name: 'Anjou' },
    { name: 'Gatineau' },
    { name: 'Mount Royal' },
    { name: 'Aylmer' },
    { name: 'Hull' },
    { name: 'Montreal' },
    { name: 'Beauport' },
    { name: 'Joliette' },
    { name: 'Montreal Region' },
    { name: 'Bromptonville' },
    { name: 'Jonquiere' },
    { name: 'Montreal-Est' },
    { name: 'Brosssard' },
    { name: 'Lachine' },
    { name: 'Quebec' },
    { name: 'Chateauguay' },
    { name: 'Lasalle' },
    { name: 'Saint-Leonard' },
    { name: 'Chicoutimi' },
    { name: 'Laurentides' },
    { name: 'Sherbrooke' },
    { name: 'LaSalle' },
    { name: 'Sorel' },
    { name: 'Coaticook' },
    { name: 'Laval' },
    { name: 'Thetford Mines' },
    { name: 'Dorval' },
    { name: 'Lennoxville' },
    { name: 'Victoriaville' },
    { name: 'Drummondville' },
    { name: 'Levis' },
  ],
  'saskatchewan': [
    { name: 'Avonlea' },
    { name: 'Melfort' },
    { name: 'Swift Current' },
    { name: 'Colonsay' },
    { name: 'Nipawin' },
    { name: 'Tisdale' },
    { name: 'Craik' },
    { name: 'Prince Albert' },
    { name: 'Unity' },
    { name: 'Creighton' },
    { name: 'Regina' },
    { name: 'Weyburn' },
    { name: 'Eastend' },
    { name: 'Saskatoon' },
    { name: 'Wynyard' },
    { name: 'Esterhazy' },
    { name: 'Shell Lake' },
    { name: 'Yorkton' },
    { name: 'Gravelbourg' },
  ],
  'yukon': [
    { name: 'Carcross' },
    { name: 'Whitehorse' },
  ],
};
